export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7228.76f022c3.jpg";